var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p'),_c('span',{staticClass:"md:flex hidden items-center"})])
}
var staticRenderFns = []

export { render, staticRenderFns }